/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Hero_By_ListeningInputs */

const en_auth_hero_by_listening = /** @type {(inputs: Auth_Hero_By_ListeningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`by listening`)
};

const es_auth_hero_by_listening = /** @type {(inputs: Auth_Hero_By_ListeningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`escuchando`)
};

/**
* | output |
* | --- |
* | "by listening" |
*
* @param {Auth_Hero_By_ListeningInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const auth_hero_by_listening = /** @type {((inputs?: Auth_Hero_By_ListeningInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Hero_By_ListeningInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_auth_hero_by_listening(inputs)
	return en_auth_hero_by_listening(inputs)
});